//@flow
import * as React from 'react';
import i18n from 'app/common/lib/i18n';
import templateConst from 'app/common/lib/templateConst';
import { Box, Divider, Icon, Link, Text } from 'gestalt';

type Props = {|
  onDismiss: Function,
|};

export default function IntellectualPropertyConfirmation({ onDismiss }: Props) {
  return (
    <React.Fragment>
      <Link href={templateConst.settings.ABOUT_COPYRIGHT_URL} onClick={onDismiss} target="blank">
        <Box
          alignItems="center"
          justifyContent="between"
          display="flex"
          direction="row"
          paddingY={6}
        >
          <Box paddingX={6}>
            <Text size="lg" weight="bold">
              {i18n._('This infringes my copyright', 'Copyright infringement statement')}
            </Text>
          </Box>
          <Box paddingX={6}>
            <Icon
              icon="arrow-forward"
              accessibilityLabel={i18n._('Go to copyright infringement')}
              color="darkGray"
            />
          </Box>
        </Box>
      </Link>
      <Divider />
      <Link href={templateConst.settings.ABOUT_TRADEMARK_FORM} onClick={onDismiss} target="blank">
        <Box
          alignItems="center"
          justifyContent="between"
          display="flex"
          direction="row"
          paddingY={6}
        >
          <Box paddingX={6}>
            <Text size="lg" weight="bold">
              {i18n._('This infringes my trademark', 'Trademark infringement statement')}
            </Text>
          </Box>
          <Box paddingX={6}>
            <Icon
              icon="arrow-forward"
              accessibilityLabel={i18n._('Go to trademark infringement')}
              color="darkGray"
            />
          </Box>
        </Box>
      </Link>
    </React.Fragment>
  );
}
